import { strings } from '@/i18n/strings';
import styles from './StarRating.module.scss';

const STAR_VALUES = [1, 2, 3, 4, 5] as const;

interface StarRatingProps {
	value: number;
	onChange?: (value: number) => void;
}

const StarIcon = () => (
	<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
		<path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
	</svg>
);

export const StarRating = ({ value, onChange }: StarRatingProps) => {
	if (!onChange) {
		return (
			<span className={styles.stars} role="img" aria-label={strings.starRating.outOfFive(value)}>
				{STAR_VALUES.map(star => (
					<span key={star} className={`${styles.star} ${star <= value ? styles.filled : styles.empty}`}>
						<StarIcon />
					</span>
				))}
			</span>
		);
	}

	return (
		<div className={styles.stars} role="radiogroup" aria-label={strings.starRating.ratingAriaLabel}>
			{STAR_VALUES.map(star => (
				<button
					key={star}
					type="button"
					role="radio"
					aria-checked={star === value}
					aria-label={strings.starRating.starLabel(star)}
					className={`${styles.star} ${star <= value ? styles.filled : styles.empty}`}
					onClick={() => onChange(star)}
				>
					<StarIcon />
				</button>
			))}
		</div>
	);
};
